var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"noPage"},[_vm._v("未配置审批详情页面，请联系管理员")])
}
var staticRenderFns = []

export { render, staticRenderFns }